import { useCallback, useEffect, useState } from 'react';

import { ActionEntityType } from '@pmp/api';

const buildStorageKey = (entityType: ActionEntityType) => `${entityType}ExternalFilters`;

const readStoredFilters = <T>(entityType: ActionEntityType): T | null => {
  try {
    const raw = localStorage.getItem(buildStorageKey(entityType));
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
};

export const useEntityExternalFilters = <T>(entityType: ActionEntityType, defaults: T) => {
  const [filters, setFilters] = useState<T>(() => readStoredFilters<T>(entityType) ?? defaults);

  useEffect(() => {
    localStorage.setItem(buildStorageKey(entityType), JSON.stringify(filters));
  }, [entityType, filters]);

  const resetFilters = useCallback(() => setFilters(defaults), [defaults]);

  return [filters, setFilters, resetFilters] as const;
};